import { itemType, itemText, } from '@/constants/storeAdjustmentHistory';
export default {
    RESET_STORE_ADJUSTMENT_DETAIL: (state) => {
        state.list = [];
        state.providerInfo = {};
        state.consumerInfo = {};
    },
    GET_PROVIDER_INFO: (state, payload) => {
        state.providerInfo = payload;
    },
    GET_CONSUMER_INFO: (state, payload) => {
        state.consumerInfo = payload;
    },
    GET_PROVIDE_LIST: (state, payload) => {
        const result = payload.reduce((acc, { _amount: amount, _taxAmount: taxAmount, _totalAmount: totalAmount, _type: type, _orderCount: orderCount, }) => {
            if (acc[itemType[type]]) {
                acc[itemType[type]].amount += amount;
                acc[itemType[type]].taxAmount += taxAmount;
                acc[itemType[type]].totalAmount += totalAmount;
                acc[itemType[type]].orderCount += orderCount;
            }
            else {
                acc[itemType[type]] = {
                    type: itemType[type],
                    text: itemText[itemType[type]],
                    amount,
                    taxAmount,
                    totalAmount,
                    orderCount,
                };
            }
            return acc;
        }, {});
        state.list = Object.values(result);
    },
};
